import { Platform } from 'react-native';
import { brand, crece, semantic, surface, text } from '@vuelto/tokens';

/** Skin POS / Catálogo sobre tema claro stone. `gold` = brand teal (compat de keys). */
export const ticketColors = {
  bg: surface.bg,
  /** Legacy counter band — preferir paper + tile en pantallas Square. */
  counter: surface.surfaceSecondary,
  paper: surface.surface,
  /**
   * Tile Square (proto `--tile #FAFBFA`): search, KPI cells, botones soft.
   * No usar surfaceSecondary (#EAF3F0) acá — se lee demasiado mint vs el proto.
   */
  paper2: '#FAFBFA',
  /** Alias explícito del proto. */
  tile: '#FAFBFA',
  /** Controles / cards accionables — Square `--border-ctl` (ink 14%). */
  rule: surface.borderControl,
  /** Separadores Square `--border` (ink 8%). */
  ruleSoft: surface.border,
  /** Soft-teal nest / hover / KPI selected. */
  brandSoft: '#E8F7F4',
  brandInk: '#115E59',
  /** brand 500 — primary teal. Preferir esto sobre `gold` (alias deprecated). */
  brandPrimary: brand[500],
  /** brand 600 — héroes/celebración (Day1NextCard). */
  brandDeep: brand[600],
  /** Borde teal semi-transparente (proto `rgba(15,118,110,.22)`). */
  brandBorderSoft: 'rgba(15, 118, 110, 0.22)',
  /** Borde teal semi-transparente (proto `rgba(15,118,110,.28)`). */
  brandBorder: 'rgba(15, 118, 110, 0.28)',
  /** Borde teal semi-transparente (proto `rgba(15,118,110,.35)` — hover). */
  brandBorderStrong: 'rgba(15, 118, 110, 0.35)',
  /** Atención Square (proto `--warn`). */
  warn: semantic.warning,
  warnBg: '#FFFBEB',
  warnBorder: 'rgba(180, 83, 9, 0.28)',
  /** @deprecated alias — brand teal */
  gold: brand[500],
  goldInk: text.onBrand,
  /**
   * Acento Crece (proto `--crece`): solo CTAs de conversión del plan pago.
   * No usar como primary genérico — eso sigue siendo `gold`/brand teal.
   */
  crece: crece[500],
  creceSoft: crece.soft,
  creceInk: crece.onAccent,
  ink: text.primary,
  ink2: text.secondary,
  ink3: text.muted,
  ok: semantic.success,
  /** Wash success (badges combo, promo aplicada). */
  okBg: 'rgba(21, 128, 61, 0.10)',
  okBorder: 'rgba(21, 128, 61, 0.18)',
  bad: semantic.danger,
  dim: surface.overlay,
  /** Sheet handle / grabber sobre paper. */
  chromeHandle: 'rgba(28, 25, 23, 0.22)',
  inkLight: text.secondary,
  card: surface.surface,
  border: surface.border,
  success: semantic.success,
} as const;

export const ticketFonts = {
  sans: Platform.OS === 'web' ? '"Plus Jakarta Sans", system-ui, sans-serif' : undefined,
  mono: Platform.OS === 'web' ? '"IBM Plex Mono", ui-monospace, monospace' : undefined,
} as const;
